var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8 5.17647C8.5198 5.17647 8.94118 4.75509 8.94118 4.23529C8.94118 3.7155 8.5198 3.29412 8 3.29412C7.4802 3.29412 7.05882 3.7155 7.05882 4.23529C7.05882 4.75509 7.4802 5.17647 8 5.17647ZM8 6.11765C8.5198 6.11765 8.94118 6.53903 8.94118 7.05882V11.3725C8.94118 11.8923 8.5198 12.3137 8 12.3137C7.4802 12.3137 7.05882 11.8923 7.05882 11.3725V7.05882C7.05882 6.53903 7.4802 6.11765 8 6.11765Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.3737a1e5bd79ee92952700243e773391.svg";
export { ForwardRef as ReactComponent };